module.exports = __webpack_public_path__ + "img/sdg_en_(14).8d5f4955.png";